module.exports = __webpack_public_path__ + "static/img/img12.a11d20ee.png";